
document.addEventListener('DOMContentLoaded', function(){
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.mialica-about-page .ma-reveal').forEach(function(el){ el.classList.add('is-visible'); });
    return;
  }
  const io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, {threshold:0.12});
  document.querySelectorAll('.mialica-about-page .ma-reveal').forEach(function(el){ io.observe(el); });
});
